// extracted by mini-css-extract-plugin
export var statItem = "_gh-1";
export var statsRow = "_gh-0";